module.exports = __webpack_public_path__ + "img/N774-2-EN.ba3b8ca9.png";